import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "environments/environment";
import { Observable, of as observableOf } from "rxjs";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  public version: string = environment.version;
  public envName: Observable<string> = observableOf("");
  public envPath: string = "components.environment." + environment.envName;

  constructor(private translateService: TranslateService) {}

  ngOnInit() {
    if (environment.envName != "production") {
      this.envName = this.translateService.get(this.envPath);
    }
  }
}
